import {Component, OnInit} from '@angular/core';
import {SurveyMonkeyService} from './survey-monkey.service';
import {FolderModel} from '../../../models/survey-monkey/folder.model';
import {SurveyModel} from '../../../models/survey-monkey/survey.model';
import {ClientEnum, ClientModel, LanguageModel, SurveySimpleModel, SurveyVersionModel} from '../../../models/survey/survey.model';
import {UsersService} from '../../users/users.service';
import {ActivatedRoute, Router} from '@angular/router';
import {SurveyService} from '../surveys.service';
import {ToasterService} from 'angular5-toaster/dist';
import {ErrorMessageModel} from '../../../models/typeform/error-message.model';
import { ImportFromSystemType } from '../../../shared/constants/input.constants';
import { Observable } from 'rxjs';
import { UserModel } from '../../../models/user/users.model';
import { AuthTokenService } from '../../../shared/services/auth-token.service';
import { isNullOrUndefined } from 'util';
import { PreviousUrlService } from '../../../shared/services/previous-url.service';

@Component({
  selector: 'app-surveymonkey',
  templateUrl: './survey-monkey.component.html',
  styleUrls: ['./survey-monkey.component.less']
})
export class SurveyMonkeyComponent implements OnInit {

  folders: FolderModel[] = [];
  folderNames: string[] = [];
  surveys: SurveyModel[] = [];
  surveyNames: string[] = [];
  masterSurvey: SurveyModel = null;
  permissions = [
    {value: 'All', text: 'All Users'},
    {value: 'Admin', text: 'Admin Only'},
    {value: 'User', text: 'Selected Users'}
  ];
  listImportType = [
    {value: 'New', text: 'Import as a new survey'},
    {value: 'Add', text: 'Add additional versions to an existing survey'}
  ];
  clients: ClientModel[] = [];
  clientNames: string[] = [];
  languages: LanguageModel[] = [];
  languageNames: string[] = [];

  isDesc = false;
  column = '';
  isSelectedAll = false;
  selectedSurveyVersionCount = 0;
  surveyVersions: SurveyModel[] = [];
  selectedPermission: any;
  selectedUserIds: number[] = [];
  users: any[] = [];
  isEnableUnspecifiedLanguage = false;
  unspecifiedLanguageName = 'English';
  isValid = false;
  importedSurveyCount = 0;

  selectedClient: ClientModel = null;
  showLoader = false;
  selectedFolderName: string;

  showOverrideSurvey = false;
  showSMError = false;
  smErrorMessage = '';
  smErrorCode = '';
  hasErrorMessage = false;
  errorMessages: ErrorMessageModel[] = [];
  disabledMasterSurvey = true;
  showWarning = false;

  showTypeformNumberQuestionError = false;
  showTypeformContentQuestionError = false;
  countContentQuestionError = 0;
  errorMessagesApi = [];
  isSkipError = false;
  importTypeSelected: any;
  listSurveysFilteredByFolder: SurveySimpleModel[];  
  existingSurveyMaster: SurveySimpleModel;
  idSurvey: number;
  client: ClientModel;
  currentUser: UserModel;
  isAdmin = AuthTokenService.isAdmin();
  isCustomerAdmin = AuthTokenService.isCustomerAdmin();
  clientDefault: string;
  isSurveyMonkeyAuthorization = true;
  
  constructor(private router: Router,
              private surveyMonkeyService: SurveyMonkeyService,
              private userService: UsersService,
              private toasterService: ToasterService,
              private surveyService: SurveyService,
              private shareService: PreviousUrlService,
              private route: ActivatedRoute) 
  {
    this.route.data.subscribe(data => {
        this.client = data.client;
    });
    this.currentUser = AuthTokenService.getUser();
  }

  ngOnInit(): void {
    if (!this.isAllowImportSurveyMonkey()) {
        this.router.navigate(['surveys']);
    }
    this.shareService.setSurveyTitle('Survey Import');
    this.surveyService.getAllActiveClient().subscribe(res => {
      res = res.filter(f => f.surveyMonkeyActivated == true);
      this.clients = res.sort((a, b) => a.name.toLowerCase() > b.name.toLowerCase() ? 1 : -1);
      this.clientNames = this.clients.map(c => c.name);
      if (this.isAdmin) {
        this.clientDefault =  ClientEnum.INTERNAL;
        this.selectedClient = this.clients.find(x => x.name === this.clientDefault);
      } else {
        this.selectedClient = this.clients.find(x => x.id === this.currentUser.clientId)
        this.clientDefault =  this.selectedClient.name;
      }
    });

    this.surveyService.getAllLanguage().subscribe(res => {
      this.languages = res.sort((a, b) => a.name.toLowerCase() > b.name.toLowerCase() ? 1 : -1);
      this.languageNames = this.languages.map(l => l.name);
    });
    
    this.importTypeSelected = this.listImportType[0];
  }

  compareUser(a, b) {
    return `${a.firstName} ${a.lastName}`.toLowerCase() > `${b.firstName} ${b.lastName}`.toLowerCase() ? 1 : -1;
  }

  loadUserByClient(id) {
    this.userService.getAllByClient(id).subscribe(res => {
      this.users = res.sort((a, b) => this.compareUser(a, b));
    });
  }

  onFolderChanged(event: any) {
    const folderName = event.value;
    this.selectedFolderName = folderName;
    const folder = this.folders.find(x => x.title === folderName);
    if (!isNullOrUndefined(folder)) {
        const folderId = folder.id;
        this.disabledMasterSurvey = false;    
        this.idSurvey = 0;
        this.showLoader = true;
        this.surveyMonkeyService.getFolderDetails(folderId, this.selectedClient.id).subscribe(res => {
        this.surveys = res.data.sort((a, b) => a.title.toLowerCase() > b.title.toLowerCase() ? 1 : -1);
        this.surveys.forEach(s => {
            if (!s.existVersion) {      
            s.isChecked = true;
            s.isEnabled = true;       
            } else { 
            s.isChecked = true;
            s.isEnabled = false;
            }
        });
        this.surveyNames = this.surveys.map(s => s.title);
        this.surveyVersions = this.surveys;
        this.masterSurvey = null;
        this.calImportedSurveyCount();
        if (this.importTypeSelected.value === 'Add') {
            this.getSurveysByWorkSpace();
        } else {          
            this.showLoader = false;
        }
        }, _ => {
        this.showLoader = false;
        });
    }
  }

  onSurveySelected(event: any) {
    const surveyName = event.value;
    const masterSurvey = this.surveys.find(s => s.title === surveyName);
    this.changeMasterSurvey(masterSurvey);
  }

  changeMasterSurvey(e) {
    this.masterSurvey = e;
    if (e) {
      this.surveyVersions = this.surveys.filter(s => s.id !== e.id);
      this.surveyVersions.forEach(s => {
        if (this.importTypeSelected.value !== 'Add') {          
          s.isChecked = s.isEnabled = true;
        }
        if (s.questionCount < e.questionCount) {
          s.isLowerNumberQuestion = true;
        } else {
          s.isLowerNumberQuestion = false;
        }
      });
      this.checkValidForm();
      this.calImportedSurveyCount();
    }
  }

  displayPermission(p) {
    return p ? p.text : null;
  }

  onPermissionSelected(event: any) {
    if (event.value !== this.selectedPermission) {
      this.selectedUserIds = [];
    }
    this.selectedPermission = event.value;
    this.checkValidForm();
  }

  onSelectedClient(event: any) {
    const clientName = event.value;
    this.selectedClient = this.clients.find(x => x.name === clientName);
    this.getSurveysByWorkSpace();
    this.checkValidForm();
    this.checkTypeFormAuthorization();
    this.loadUserByClient(this.selectedClient.id);
  }

  sort(by: string) {
    this.isDesc = !this.isDesc;
    this.column = by;
    const direction = this.isDesc ? 1 : -1;
    this.surveyVersions.sort((a, b) => a[by] < b[by] ? -1 * direction : direction);
  }

  onAllSurveyVersionSelected(event: any) {
    this.surveyVersions.filter(s => s.isEnabled).forEach(s => s.isChecked = event);
    this.checkValidForm();
    this.calImportedSurveyCount();
  }

  displayUserExpr(s) {
    return `${s.firstName} ${s.lastName}`;
  }

  onUsersSelected(event) {
    this.selectedUserIds = event;
    this.checkValidForm();
  }

  onSurveyVersionSelected(event: any, s: SurveyModel) {
    s.isChecked = !s.isChecked;
    this.checkValidForm();
    this.calImportedSurveyCount();
  }

  onGoClicked() {
    const languageId = this.languages.find(x => x.name === this.unspecifiedLanguageName).id;
    this.surveys.filter(x => !x.languageId && x.isChecked).forEach(x => x.languageId = languageId);
  }

  onUnspecifiedLanguageSelected(e: any) {
    this.unspecifiedLanguageName = e.value;
  }

  cancel() {
    this.router.navigate(['surveys']);
  }

  import(override = false, ignoredWarning = false) {
    this.showWarning = !ignoredWarning
      && (this.masterSurvey.hasUnsupportedQuestion || this.surveyVersions.filter(s => s.isChecked).some(s => s.hasUnsupportedQuestion));
    if (!this.showWarning) {
      this.showLoader = true;
      this.showOverrideSurvey = false;
      this.showSMError = false;
      const importSurvey = {
        clientId: this.selectedClient.id,
        masterId: this.masterSurvey.id,
        versions: this.surveyVersions
          .filter(s => s.isChecked && !s.existVersion)
          .map(s => {
            return {id: s.id, languageId: s.languageId};
          }),
        override,
        folderName: this.selectedFolderName,
        permission: this.selectedPermission.value,
        userIds: this.selectedUserIds,
        isSkipValidate: this.isSkipError,
        surveyId: 0
      };

      let importSurveyObservable: Observable<any>;
      if (this.importTypeSelected.value =="Add") {      
        importSurvey.surveyId = this.existingSurveyMaster.id;
        importSurveyObservable = this.surveyMonkeyService.ImportExistingSurvey(importSurvey);
      } else {     
        importSurveyObservable = this.surveyMonkeyService.importSurvey(importSurvey); 
      }

      importSurveyObservable.subscribe(res => {
        this.isSkipError = false;
        const success = res.success;
        if (success) {
          this.toasterService.pop('success', 'Import complete');
          this.router.navigate(['surveys']);
        } else {
          const error: string = res.error;
          if (error === 'duplicate_survey') {
            this.showOverrideSurvey = true;
            this.isSkipError = true;
          } else if (error === 'validate_survey') {
            this.errorMessagesApi = res.messages;
            this.controlImportErrorDialog();
            this.hasErrorMessage = true;
            this.errorMessages = res.messages.filter(item => item.errorType !== "NumberQuestion");
          }
        }
        this.showLoader = false;
      }, err => {
        this.isSkipError  = false;
        const message = err.message;
        if (message && message.indexOf('surveymonkey_error') === 0) {
          this.showSMError = true;
          this.smErrorCode = message.split(';')[1];
          this.smErrorMessage = message.split(';')[2];
        } else {
          this.toasterService.pop('error', 'Something went wrong');
        }
        this.showLoader = false;
      });
    }
  }

  getLanguageName(id: number): string {
    if (id !== null && id !== undefined) {
      return this.languages.find(la => la.id === id).name;
    }
  }

  onSelectedLanguage(e: any, s: SurveyModel) {
    const langName = e.value;
    s.languageId = this.languages.find(x => x.name === langName).id;
    this.checkValidForm();
  }

  getFolder() {
    this.showLoader = true;
    this.surveyMonkeyService.getAllFolder(this.selectedClient.id).subscribe(res => {
      this.folders = res.data.sort((a, b) => a.title.toLowerCase() > b.title.toLowerCase() ? 1 : -1);
      this.folderNames = this.folders.map(f => f.title);
      this.showLoader = false;
    }, _ => {
        this.showLoader = false;
    });
  }

  private checkValidForm() {
    this.isEnableUnspecifiedLanguage = this.masterSurvey
      && this.surveyVersions.some(s => s.isChecked && !s.languageId);
      if (this.importTypeSelected.value =="Add") {  
        let additionalSurveys = this.surveyVersions.filter(f => (!f.existVersion && f.isChecked ) ).length;
        if (additionalSurveys == 0) {
          this.isValid = false;  
          return;        
        }
      }

    if (this.selectedClient && this.masterSurvey && this.selectedPermission) {
      if (this.selectedPermission.value === 'User' && this.selectedUserIds.length === 0) {
        this.isValid = false;
      } else {
        if (this.importTypeSelected.value =="Add") {    
          let quantitySelected = this.surveyVersions.filter(f => (f.isChecked && !f.existVersion  ) ).length;            
            if (quantitySelected > 0) {              
              this.isValid = !(this.surveyVersions.filter(f => (f.isChecked && !f.existVersion && !f.languageId  ) ).length > 0) ;
            } else {
              this.isValid = false;
            }  
        } else {          
          this.isValid = !(this.surveyVersions.filter(f => f.isChecked && !f.languageId).length > 0);
        }
      }
      return;
    }
    this.isValid = false;
  }

  private calImportedSurveyCount() {
    this.isEnableUnspecifiedLanguage = this.masterSurvey
      && this.surveyVersions.filter(x => x.isChecked && !x.languageId).length > 0;
      
    this.selectedSurveyVersionCount = this.surveyVersions.filter(f => f.isChecked && !f.existVersion).length;
    this.importedSurveyCount = this.selectedSurveyVersionCount + (this.masterSurvey && this.importTypeSelected.value !="Add" ? 1 : 0);

    const enabledSurveyVersionCount = this.surveyVersions.filter(f => f.isEnabled).length;
    this.isSelectedAll = enabledSurveyVersionCount > 0 && enabledSurveyVersionCount === this.selectedSurveyVersionCount;
  }

  goToTypeform() {
    this.router.navigate(['surveys/import-typeform']);
  }

  controlImportErrorDialog(isSkipNumberQuestionError = false, isSkipContentError = false) {
    if(this.isNumberQuestionError(this.errorMessagesApi) && !isSkipNumberQuestionError) {
      this.showTypeformNumberQuestionError = true;
    }
    else {
      const numberContentError = this.getNumberContentQuestionError(this.errorMessagesApi);
      if (numberContentError && !isSkipContentError) {
        this.countContentQuestionError = numberContentError;
        this.showTypeformContentQuestionError = true;
      } else {
        this.isSkipError = true;
        this.import(false, true);
      }
    }
  }

  getNumberContentQuestionError(listError: any) {
    return listError.filter(item => item.errorType === "QuestionContent").length;
  }

  isNumberQuestionError(listError: any) {
    return listError.filter(item => item.errorType === "NumberQuestion").length > 0;
  }

  goToImportCSV() {
    this.router.navigate(['surveys/import-csv']);
  }

  onImportTypeChanged(event: any) {
    this.importTypeSelected = event;
    if (event.value === 'Add') {
      this.showLoader = true;  
      this.getSurveysByWorkSpace();
      this.surveyVersions.forEach(f => f.isLowerNumberQuestion = false);
    } else {
      this.masterSurvey = null;
      this.surveyVersions.forEach(form => {
         form.existVersion = false;
          form.isChecked = true;
          form.isEnabled = true;
          form.languageId = null;

      });
    }
  }

  
  getSurveysByWorkSpace(){
    this.surveyService.getSurveysByWorkSpaceName(this.selectedFolderName, ImportFromSystemType.SurveyMonKey, this.selectedClient.id).subscribe(response=>{
      if (response) {        
        this.listSurveysFilteredByFolder = response; 
        
        if (this.listSurveysFilteredByFolder && this.listSurveysFilteredByFolder.length === 1) {   
          this.existingSurveyMaster = this.listSurveysFilteredByFolder[0];
        }
      }      
    }, err=>{ },
    ()=> {
      this.showLoader = false; 
      this.masterSurvey = null;
      this.checkValidForm();
    });
  }

  
  onSurveyLocalChange(event: any){
    this.existingSurveyMaster = event.value;
    this.idSurvey = this.existingSurveyMaster.id;
    this.masterSurvey =  this.surveys.find(f => f.title === this.existingSurveyMaster.name);
    // this.surveys.find(f => f.isMaster === true).isMaster = false;
 

    this.surveyService.getSurveyVersionLanguage(this.idSurvey).subscribe(response=>{
      let surveyVersionLanguage: SurveyVersionModel[] = response;
      this.surveyVersions.forEach(form => {
        let surveyVersionFound = surveyVersionLanguage.find(s=>s.nameVersion === form.title);
        if(surveyVersionFound){
          form.existVersion = true;
          form.isChecked = true;
          form.isEnabled = false;
          form.languageId = surveyVersionFound.languajeID;
        } else {
          form.existVersion = false;
          form.isChecked = false;
          form.isEnabled = true;
          form.languageId = null;
        }
      });

      if (this.masterSurvey) {      
        this.masterSurvey.isMaster = true;        
        this.changeMasterSurvey(this.masterSurvey);
      } else {      
        this.toasterService.pop('error', 'Master survey no found ');
      }
    });
  }

  isAllowImportTypeForm(): boolean {
    return this.isAdmin || (this.isCustomerAdmin && (this.currentUser.allowImportTypeForm && this.client.typeFormActivated));
  }

  isAllowImportCSV(): boolean {
    return this.isAdmin || (this.isCustomerAdmin && (this.currentUser.allowImportCSV));
  }

  isAllowImportSurveyMonkey(): boolean {
    return this.isAdmin || (this.isCustomerAdmin && (this.currentUser.allowImportSurveyMonkey && this.client.surveyMonkeyActivated));
  }

  checkTypeFormAuthorization() {
    this.selectedFolderName = null;
    this.folderNames = [];
    this.showLoader = true;
    setTimeout(() => {
        this.surveyMonkeyService.isSurveyMonkeyAuthorization(this.selectedClient.id).subscribe(res => {
            this.isSurveyMonkeyAuthorization = res;
            if (this.isSurveyMonkeyAuthorization) {
                this.getFolder();
            }
            this.showLoader = false;
        })
    });
  }
}



// WEBPACK FOOTER //
// ./src/app/routes/surveys/survey-monkey/survey-monkey.component.ts